import { useEffect, useState } from 'react';

/**
 * Subscribe to a CSS media query. Returns true when the query matches.
 * Updates synchronously on viewport changes so callers can swap content
 * (e.g. a portrait vs. landscape video source) without flicker.
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() =>
    typeof window !== 'undefined' ? window.matchMedia(query).matches : false,
  );
  useEffect(() => {
    const mq = window.matchMedia(query);
    const handler = (e: MediaQueryListEvent) => setMatches(e.matches);
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, [query]);
  return matches;
}
